import PropTypes from 'prop-types';
import React, { Component } from "react";
import Relay from "react-relay"
import { dispatch } from "../../Dispatcher"
import SetsBreadcrumb from "../elements/SetsBreadcrumb"
import LoadMoreLink from "../elements/LoadMoreLink"
import Masonry from "../elements/Masonry"
import SearchDisplayTools from "./SearchDisplayTools"
import SetResult from "./SetResult"
import { width } from "../../scripts/size"
import State from "../../stores/State"
import { FormattedMessage } from "react-intl"
import { setArticleStyle } from "../../actions"
import { default as setsMessages } from "../../messages/sets"
import { SET_ARTICLE_STYLES, MOBILE_ARTICLE_STYLE_ID } from "../../constants"
import { getStyles, getStyleTag } from '../../styles/dynamicStyles'

class Sets extends Component {
  state = {
    articleStyle: State.get("articleStyle"),
    articleStyles: SET_ARTICLE_STYLES
  }

  componentDidMount() {
    this.handleArticleStyles()
    this._stateListener = State.addListener(() => {
      const articleStyle = State.get("articleStyle")
      if (articleStyle !== this.state.articleStyle) {
        this.setState({ articleStyle })
      }
    })
    window.addEventListener("resize", this.handleArticleStyles)
  };

  componentWillUnmount() {
    if (this._stateListener) {
      this._stateListener.remove()
    }
    window.removeEventListener("resize", this.handleArticleStyles)
  }

  handleArticleStyles = () => {
    if (width() <= 512) {
      this.setState({ articleStyle: MOBILE_ARTICLE_STYLE_ID })
      dispatch(setArticleStyle(MOBILE_ARTICLE_STYLE_ID))
    }
  }

  render() {
    const { articleStyle, articleStyles } = this.state
    const { viewer } = this.props
    const { userSets } = viewer
    const sets = userSets.edges.map(edge => edge.node)
    const hasNextPage = sets.resources && sets.resources.pageInfo.hasNextPage

    // TODO use sort... see function commented out above
    // const results = this._sortResources(sets).map((set) =>
    const results =
      sets.map(set => <SetResult key={set.id} userSet={set} />) || []

    return (
      <div>
        {getStyleTag([
          'search-results__tools', 
          'search-results__listings', 
          'sets__listings'
        ])}
        <div className="search-results__tools">
          <div className="column row">
            <div className="search-results__tools-inner">
              <div className="c-results-panel search-results__panel" style={getStyles('c-results-panel')}>
                <SearchDisplayTools articleStyles={articleStyles} withSort={false} />
                <SetsBreadcrumb viewer={viewer} />
              </div>
            </div>
          </div>
        </div>
        <div className="column row">
          <section
            className="search-results__listings"
            style={getStyles('search-results__listings')}
            data-article-style={articleStyle}
          >
            {results.length === 0 && (
              <p>
                <FormattedMessage {...setsMessages.noSetsAdded} />
              </p>
            )}
            {results.length > 0 && (
              <div>
                {articleStyle === "fluid" ? (
                  <Masonry elementType="div">{results}</Masonry>
                ) : (
                  results
                )}
              </div>
            )}
            {hasNextPage && (
              <LoadMoreLink onClick={this._handleLoadMore}>
                <FormattedMessage {...setsMessages.loadMoreItems} />
              </LoadMoreLink>
            )}
          </section>
        </div>
      </div>
    )
  }
}

Set.propTypes = {
  viewer: PropTypes.object.isRequired
}

export default Relay.createContainer(Sets, {
  fragments: {
    viewer: () => Relay.QL`
    fragment on Viewer {
      userSets: user_sets(first: 1000) {
        edges {
          node {
            id
            ${SetResult.getFragment("userSet")}
          }
        }
      }
      ${SetsBreadcrumb.getFragment("viewer")}
    }
    `
  }
})



// WEBPACK FOOTER //
// ./webapp/components/modules/Sets.js